import { Deserializable } from './deserializable';
import { FileInfo } from './fileInfo';
import { MonitorInteractionItem } from './monitor-interaction-item';
import { User } from './user';

export class Contestation implements Deserializable {
  id: number;
  explanation: string;
  registerDate: Date;
  status: any;
  minuteSelected: string;
  user: User;
  createdByAi?: boolean;
  validatedBy?: User;

  monitorInteractionItem?: MonitorInteractionItem;

  fileInfo: FileInfo;

  public file?: File;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
